export default __webpack_public_path__ + "static/media/img-0334-botswana-half-face.771f366e.png";